import { useSyncExternalStore } from "react";
import {
  isReadingMode,
  setReadingMode,
  subscribe,
  toggleReadingMode,
} from "@/lib/readingMode";

/**
 * React access to the global reading-mode preference.
 * `reading` is the effective on/off state used to simplify typography and
 * calm motion across the site.
 */
export function useReadingMode() {
  const reading = useSyncExternalStore(subscribe, isReadingMode, () => false);
  return { reading, setReading: setReadingMode, toggleReading: toggleReadingMode };
}
